import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { Conclave, ConclaveApiService } from '../conclave-api.service';
import { FilterBaseAccessService } from '../../../auth/filterbase-access';
@Component({
  selector: 'app-conclave-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './conclave-detail.component.html',
  styleUrl: './conclave-detail.component.css'
})
export class ConclaveDetailComponent {
  conclave: Conclave | null = null;
  isLoading = false;
  errorMessage: string | null = null;
  conclave_view: boolean=false;
  conclave_share: Boolean=false;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly conclaveApi: ConclaveApiService,
    access: FilterBaseAccessService,
   
  ) {
       this.conclave_view = access.checkaccessforfiltersandactions('conclave view');
        this.conclave_share = access.checkaccessforfiltersandactions('conclave share');
  }
  

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (!id) return;
      this.loadConclaveById(id);
    });
  }

  private loadConclaveById(id: string): void {
    this.isLoading = true;
    this.errorMessage = null;

    this.conclaveApi
      .getConclaveById(id)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.conclave = res?.data ?? null;
          if (!this.conclave) this.errorMessage = 'Conclave not found.';
        },
        error: (err) => {
          console.error('Conclave detail API error:', err);
          this.conclave = null;
          this.errorMessage = 'Failed to load conclave details.';
        }
      });
  }

  get locationText(): string {
    if (!this.conclave) return '';
    const { venue, city, state } = this.conclave;
    return [venue, city, state].filter(Boolean).join(', ');
  }

  get badgeText(): string {
    return this.conclave?.ticket_type ?? 'Free';
  }

  get coverImageUrl(): string {
    const url = this.conclave?.cover_image_url;
    if (!url) return 'assets/dummy_thumbnail.png';
    // Some backend strings may have trailing quotes.
    return String(url).replace(/"+$/, '');
  }

  /**
   * Show share button only for upcoming conclaves.
   * Criteria: conclave.end_date exists? compare that, otherwise compare start_date.
   */
  get isUpcomingConclave(): boolean {
    if (!this.conclave) return false;

    const now = new Date();
    const end = this.conclave.end_date ? new Date(this.conclave.end_date) : null;
    const start = this.conclave.start_date ? new Date(this.conclave.start_date) : null;

    const ref = end && !Number.isNaN(end.getTime()) ? end : start;
    if (!ref || Number.isNaN(ref.getTime())) return false;

    return ref.getTime() >= now.getTime();
  }

  formatDate(dateStr?: string | null): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  formatMonthShort(dateStr?: string | null): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { month: 'short' });
  }

  formatDayNumber(dateStr?: string | null): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { day: '2-digit' });
  }
}

